const MultiSelectComponent = {
    templateUrl: '/ui/multiSelect/multiSelect.tpl.html',
    controller: 'multiSelectController',
    bindings: {
        itemsList: '<',
        selectedValue: '<',
        itemName: '<',
        promptValue: '<',
        appendToBody: '<',
        optionalPrefix: '<',
        autoExpand: '<',
        isDisabled: '<',
        delimiter: '<',
        fixedMultipleSelectionButtonLabel: '<',
        fixedAllSelectedButtonLabel: '<',
        isListLoadDynamically:'<',
        truncateCharLength:'<',
        filterTextPrompt:'<',
        width:'<',
        onChange: '&',
        tooltipMessage: '<',
    }
};

angular.module('umCore')
    .component('uiMultiSelect', MultiSelectComponent);
